import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import DigitalGatewayToKerala from "./sections/DigitalGatewayToKerala";
import TheFlixStandard from "./sections/TheFlixStandard";
import CooperationProcess from "./sections/CooperationProcess";
import VictoryMetrics from "./sections/VictoryMetrics";
import VoicesOfSatisfaction from "./sections/VoicesOfSatisfaction";
import ReadyToScaleYourOperations from "./sections/ReadyToScaleYourOperations";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <DigitalGatewayToKerala />
      <TheFlixStandard />
      <CooperationProcess />
      <VictoryMetrics />
      <VoicesOfSatisfaction />
      <ReadyToScaleYourOperations />
      <Footer />
    </div>;
}